module.exports = __webpack_public_path__ + "img/2494.0feec007.png";